import React, { useEffect, useState } from "react";
import { Table, Button, Switch } from "antd";
import { del, get, post } from "../../api/axios";
import { Link } from "react-router-dom";
import { message, Popconfirm } from "antd";
import { Pagination } from "antd";
import { checkPermission } from "../auth/ProtectedRoutes";
import SearchBar from "../../utils/SearchBar";

const Cities = () => {
  const columns = [
    {
      title: "صورة الميدينة",
      dataIndex: "image",
      render: image => (
        <span>
          <img
            src={image}
            alt="alt"
            class="rounded"
            style={{
              height: "100px",
              width: "100px",
              objectFit: "cover",
            }}
          />
        </span>
      ),
    },
    {
      title: "الاسم بالعربي",
      dataIndex: "name_ar",
    },
    {
      title: "الاسم بالانجليزي",
      dataIndex: "name_en",
    },
    {
      title: "اسم المنطقة بالعربي",
      dataIndex: "region_name_ar",
    },
    {
      title: "اسم المنطقة بالانجليزي",
      dataIndex: "region_name_en",
    },
    {
      title: "الحالة",
      dataIndex: "id",
      render: (id, { status }) => (
        <>
          <Switch
            onChange={() => handleChangeStatus(id, status)}
            checked={status}
            style={{
              margin: 16,
            }}
          />
        </>
      ),
    },
    {
      title: "الرئسية",
      dataIndex: "id",
      render: (id, { is_home }) => (
        <>
          <Switch
            onChange={() => handleChangeHome(id, is_home)}
            checked={is_home}
            style={{
              margin: 16,
            }}
          />
        </>
      ),
    },

    {
        title: 'حذف',
        dataIndex: 'id',
        render: (id) => (
            <Popconfirm
                title="حذف العنصر"
                description="هل أنت متأكد من حذف هذه العنصر؟"
                onConfirm={() => confirm(id)}
                onCancel={cancel}
                okText="نعم"
                cancelText="لا"
            >
                <Button danger >
                    حذف
                </Button>
            </Popconfirm>
        ),
    },
  ];

  if (checkPermission("update-city")) {
    columns.push({
      title: "تعديل",
      dataIndex: "id",
      render: id => (
        <button className="btn btn-outline-warning btn-sm p-0">
          <Link
            className="color-inherit text-decoration-none py-1 px-2 d-block"
            to={`/cities/edit/${id}`}
          >
            تعديل
          </Link>
        </button>
      ),
    });
  }


  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
   const [debouncedValue, setDebouncedValue] = useState(searchQuery);
  const [total, setTotal] = useState(1);

  const handleChangeStatus = (id, status) => {
    post(`change-city-status/${id}`, { status: !status });
    message.success("تم تغير الحالة");

    const newData = [];
    data.map(item => {
      if (item.id == id) {
        newData.push({ ...item, status: !item["status"] });
      } else {
        newData.push(item);
      }
    });
    setdata(newData);
    // ////console.log('newData',newData);
  };
  const handleChangeHome = (id, is_home) => {
    post(`change-city-home/${id}`, { status: !is_home });
    message.success("تم تغير الحالة");

    const newDataHome = [];
    data.map(item => {
      if (item.id == id) {
        newDataHome.push({ ...item, is_home: !item["is_home"] });
      } else {
        newDataHome.push(item);
      }
    });
    setdata(newDataHome);
    // ////console.log('newData',newData);
  };

  useEffect(() => {
    // return () => {
    get(`cities?page=1&search=${searchQuery}`).then(res => {
      setdata(res.data.data);
      setTotal(res.data.meta.last_page);
      setLoading(false);
    });

    // };
  }, [debouncedValue]);

  // useEffect(() => {

  //     return () => {

  //     };
  // }, [input]);

  const handleDelet = id => {
    del(`cities/${id}`);
    let dateFilter = data.filter(item => item.id !== id);
    setdata(dateFilter);
  };

  const confirm = id => {
    ////console.log(id);
    handleDelet(id);
    message.success("تم الامر بنجاح");
  };
  const cancel = e => {
    ////console.log(e);
    message.error("تم الغاء الامر");
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const onSelectChange = newSelectedRowKeys => {
    ////console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    selections: [
      Table.SELECTION_ALL,
      Table.SELECTION_INVERT,
      Table.SELECTION_NONE,
    ],
  };
  const handlePagination = pageNumber => {
    setLoading(true);

    get(`cities?page=${pageNumber}`).then(res => {
      setdata(res.data.data);
      setLoading(false);
    });
  };

  return (
    <div>
      <div className="row">
      
        {checkPermission("create-city") && (
          <div className="col-lg-4 offset-lg-4 mb-3">
              <Link
                className="text-decoration-none d-block h-100"
                to="/cities/add"
              >
                <Button type="primary" block>
                {" "}
                إضافة{" "}
            </Button>
              </Link>
          </div>
        )}
        <SearchBar
          setSearchQuery={setSearchQuery}
          searchQuery={searchQuery}
          debouncedValue={debouncedValue}
          setDebouncedValue={setDebouncedValue}
        />
        <div className="col-12 grid-margin stretch-card">
          <div className="w-100">
            <Table
              locale={{ emptyText: "لا يوجد عناصر" }}
              loading={loading}
              pagination={false}
              scroll={{
                y: "65vh",
                x: 650,
              }}
              // rowSelection={rowSelection}
              columns={columns}
              dataSource={data}
              size="middle"
            />
            <Pagination
              defaultCurrent={1}
              className="mt-4 d-flex align-items-center justify-content-center"
              position="bottomCenter"
              total={total * 10}
              onChange={handlePagination}
            />
            {/* <div className='text-center mt-3 btn-delete-table'>
              <Button type="primary" danger  size='large' >
                حذف
              </Button>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cities;
